import { HttpClient } from 'shared/libs/http';
import { ApiResponseDto } from 'shared/types';
import { JobAccdetailResponse } from './types';

export class JobApplicantsApiService {
   public static getAccDetail(dto: { slug: string }) {
      return HttpClient.post<JobAccdetailResponse>(`/job/accdetail/${dto.slug}`, null);
   }

   public static changeStatus(dto: {
      slug: string;
      userId: number;
      candidateId: number;
      status: string;
   }) {
      return HttpClient.post<JobAccdetailResponse>(`/job/accdetail/${dto.slug}`, {
         candidate_id: dto.candidateId,
         status_change: dto.status,
         user_id: dto.userId,
      });
   }

   public static getCandidatePdfCv(dto: { id: number }) {
      return HttpClient.get<Blob>(`/jobApply/downloadFile/${dto.id}`, {
         responseType: 'blob',
      });
   }

   public static addEmployerComment(dto: { id: number; comment: string }) {
      return HttpClient.post<Blob>(`/job_apply/${dto.id}/comment`, {
         comment: dto.comment,
      });
   }

   public static deleteEmployerComment(dto: { id: number }) {
      return HttpClient.delete<Blob>(`/job_apply/${dto.id}/comment`);
   }

   public static updateRating(dto: { id: number; val: number }) {
      return HttpClient.post<Blob>(`/job/updateRating/${dto.id}/${dto.val}`, null);
   }

   public static sendEmailToCandidates(dto: {
      job_id: number;
      subject: string;
      message: string;
      email_address: string;
   }) {
      return HttpClient.post<ApiResponseDto<string>>(`/candidates/sendmailToalljobseekers`, dto);
   }
}
